import { addSeconds } from 'date-fns';
import { action, observable } from 'mobx';
import { HttpClient, IConfig } from 'Mri.Web.Common';

export class DisplaysChartsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadChartConfigAsync(serialNumber: string) {
        const chartConfig = await this.httpClient.get<Mri.DisplayCharts.ChartConfigPoll>(
            `/api/v1/displays/${serialNumber}/charts`
        );

        if (chartConfig) this.displaysCharts.set(chartConfig.displaySerialNumber, chartConfig);
    }

    @action
    public async loadTrackDataAsync(
        serialNumber: string,
        varNum: number,
        startTime: Date,
        endTime: Date,
        samplePeriodSeconds: number,
        append: boolean,
        config?: IConfig
    ) {
        if (!this.displayTrackDatas.has(serialNumber)) {
            this.displayTrackDatas.set(serialNumber, new Map<number, Mri.DisplayCharts.TrackDataPoll>());
        }

        const trackDatas = this.displayTrackDatas.get(serialNumber)!;
        const existingTrackDataPoll = trackDatas.get(varNum);

        if (append && existingTrackDataPoll) {
            const { trackData, trackStartTime, secsPerSample } = existingTrackDataPoll;
            const existingDataLength = trackData.length * secsPerSample;

            startTime = addSeconds(trackStartTime, existingDataLength + secsPerSample);

            if (startTime >= endTime) return;
        }

        config = {
            ...config,

            params: {
                startTime,
                endTime,
                samplePeriodSeconds,
            },
        };

        const trackDataPoll = await this.httpClient.get<Mri.DisplayCharts.TrackDataPoll>(
            `/api/v1/displays/${serialNumber}/tracks/${varNum}`,
            config
        );

        if (trackDataPoll) {
            if (append && existingTrackDataPoll) {
                for (const v of trackDataPoll.trackData) {
                    existingTrackDataPoll.trackData.push(v);
                }
            } else {
                trackDatas.set(varNum, trackDataPoll);
            }
        }
    }

    @observable
    public displaysCharts = new Map<string, Mri.DisplayCharts.ChartConfigPoll>();
    @observable
    public displayTrackDatas = new Map<string, Map<number, Mri.DisplayCharts.TrackDataPoll>>();

    private readonly httpClient: HttpClient;
}
